import { MenuDivider } from '@fiverr-private/dropdown';

export default MenuDivider;
